import base from './base2.repository';

export default {
    ...base,
    loadBodyguardServices(filters, page){
        const params = {...filters, page: page};
        return this.get(`bodyguard-services`, params);
    },
    saveBodyguardService(store) {
        return this.post(`bodyguard-services`, store);
    },
    updateBodyguardService(payload, id) {
        return this.put('bodyguard-services/' + id, payload);
    },
    deleteBodyguardService(id){
        return this.delete('bodyguard-services/'+ id);
    },
    finishBodyguardService(payload){
        return this.post(`bodyguard-services/finish`, payload);
    },
    saveCheckpoint(payload){
        return this.post(`bodyguard-services/checkpoint`, payload);
    },
    deleteCheckpoint(id){
        return this.delete('bodyguard-services/checkpoint/'+id);
    },
    hasOpenServices: (userId) => base.get('bodyguard-services/has-open-services', { user: userId })
}